/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  Error,
  FinaElectronicDevice,
  FinaElectronicDeviceSuccessResponse,
  RegisterFinaDeviceBody,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * List all electronic devices for a business premise
 * @summary List electronic devices
 */
export type listFinaDevicesResponse200 = {
  data: FinaElectronicDevice[]
  status: 200
}

export type listFinaDevicesResponse400 = {
  data: Error
  status: 400
}

export type listFinaDevicesResponse401 = {
  data: Error
  status: 401
}

export type listFinaDevicesResponse403 = {
  data: Error
  status: 403
}

export type listFinaDevicesResponse404 = {
  data: Error
  status: 404
}

export type listFinaDevicesResponse500 = {
  data: Error
  status: 500
}

export type listFinaDevicesResponseSuccess = (listFinaDevicesResponse200) & {
  headers: Headers;
};
export type listFinaDevicesResponseError = (listFinaDevicesResponse400 | listFinaDevicesResponse401 | listFinaDevicesResponse403 | listFinaDevicesResponse404 | listFinaDevicesResponse500) & {
  headers: Headers;
};

export type listFinaDevicesResponse = (listFinaDevicesResponseSuccess | listFinaDevicesResponseError)

export const getListFinaDevicesUrl = (id: string,) => {


  

  return `/fiscalization/fina/premises/${id}/devices`
}

export const listFinaDevices = async (id: string, options?: RequestInit): Promise<listFinaDevicesResponse> => {
  
  return customFetch<listFinaDevicesResponse>(getListFinaDevicesUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Register an electronic device (cash register, POS) for a business premise. Device ID must be digits only.
 * @summary Register electronic device
 */
export type registerFinaDeviceResponse201 = {
  data: FinaElectronicDeviceSuccessResponse
  status: 201
}

export type registerFinaDeviceResponse400 = {
  data: Error
  status: 400
}

export type registerFinaDeviceResponse401 = {
  data: Error
  status: 401
}

export type registerFinaDeviceResponse403 = {
  data: Error
  status: 403
}

export type registerFinaDeviceResponse404 = {
  data: Error
  status: 404
}

export type registerFinaDeviceResponse422 = {
  data: ValidationError
  status: 422
}

export type registerFinaDeviceResponse500 = {
  data: Error
  status: 500
}

export type registerFinaDeviceResponseSuccess = (registerFinaDeviceResponse201) & {
  headers: Headers;
};
export type registerFinaDeviceResponseError = (registerFinaDeviceResponse400 | registerFinaDeviceResponse401 | registerFinaDeviceResponse403 | registerFinaDeviceResponse404 | registerFinaDeviceResponse422 | registerFinaDeviceResponse500) & {
  headers: Headers;
};

export type registerFinaDeviceResponse = (registerFinaDeviceResponseSuccess | registerFinaDeviceResponseError)

export const getRegisterFinaDeviceUrl = (id: string,) => {


  

  return `/fiscalization/fina/premises/${id}/devices`
}

export const registerFinaDevice = async (id: string,
    registerFinaDeviceBody: RegisterFinaDeviceBody, options?: RequestInit): Promise<registerFinaDeviceResponse> => {
  
  return customFetch<registerFinaDeviceResponse>(getRegisterFinaDeviceUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      registerFinaDeviceBody,)
  }
);}
  

/**
 * Get a single electronic device by ID
 * @summary Get electronic device
 */
export type getFinaDeviceResponse200 = {
  data: FinaElectronicDevice
  status: 200
}

export type getFinaDeviceResponse400 = {
  data: Error
  status: 400
}

export type getFinaDeviceResponse401 = {
  data: Error
  status: 401
}

export type getFinaDeviceResponse403 = {
  data: Error
  status: 403
}

export type getFinaDeviceResponse404 = {
  data: Error
  status: 404
}

export type getFinaDeviceResponse500 = {
  data: Error
  status: 500
}

export type getFinaDeviceResponseSuccess = (getFinaDeviceResponse200) & {
  headers: Headers;
};
export type getFinaDeviceResponseError = (getFinaDeviceResponse400 | getFinaDeviceResponse401 | getFinaDeviceResponse403 | getFinaDeviceResponse404 | getFinaDeviceResponse500) & {
  headers: Headers;
};

export type getFinaDeviceResponse = (getFinaDeviceResponseSuccess | getFinaDeviceResponseError)

export const getGetFinaDeviceUrl = (id: string,) => {


  

  return `/fiscalization/fina/devices/${id}`
}

export const getFinaDevice = async (id: string, options?: RequestInit): Promise<getFinaDeviceResponse> => {
  
  return customFetch<getFinaDeviceResponse>(getGetFinaDeviceUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Deactivate an electronic device.
 * @summary Delete electronic device
 */
export type deleteFinaDeviceResponse200 = {
  data: FinaElectronicDeviceSuccessResponse
  status: 200
}

export type deleteFinaDeviceResponse400 = {
  data: Error
  status: 400
}

export type deleteFinaDeviceResponse401 = {
  data: Error
  status: 401
}

export type deleteFinaDeviceResponse403 = {
  data: Error
  status: 403
}

export type deleteFinaDeviceResponse404 = {
  data: Error
  status: 404
}

export type deleteFinaDeviceResponse422 = {
  data: ValidationError
  status: 422
}

export type deleteFinaDeviceResponse500 = {
  data: Error
  status: 500
}

export type deleteFinaDeviceResponseSuccess = (deleteFinaDeviceResponse200) & {
  headers: Headers;
};
export type deleteFinaDeviceResponseError = (deleteFinaDeviceResponse400 | deleteFinaDeviceResponse401 | deleteFinaDeviceResponse403 | deleteFinaDeviceResponse404 | deleteFinaDeviceResponse422 | deleteFinaDeviceResponse500) & {
  headers: Headers;
};

export type deleteFinaDeviceResponse = (deleteFinaDeviceResponseSuccess | deleteFinaDeviceResponseError)

export const getDeleteFinaDeviceUrl = (id: string,) => {


  

  return `/fiscalization/fina/devices/${id}`
}

export const deleteFinaDevice = async (id: string, options?: RequestInit): Promise<deleteFinaDeviceResponse> => {
  
  return customFetch<deleteFinaDeviceResponse>(getDeleteFinaDeviceUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

